import { createApp } from 'vue'
import VueScrollTo from 'vue-scrollto'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/scss/index.scss'

createApp(App)
  .use(store)
  .use(router)
  .use(VueScrollTo)
  .mount('#app')

